export const isObject = arg => {
  return Object.prototype.toString.call(arg).indexOf('Object') !== -1;
};
